module.exports = __webpack_public_path__ + "342be5daf51a69ea3e12b3d45f58bdf2.pdf";